import {EnvConfig} from './envConfig.interface';
import {getConfiguration} from './dotEnvConfiguration';

const configuration = getConfiguration();

const stagingConfigBase: Omit<EnvConfig, 'host'> = {
  production: false,
  embedHostingBaseUrl: configuration.HOSTING_BASE_URL,
  accountManagementUrl: 'https://account.stage.simpleclub.com',
  apiBaseUrl: configuration.API_BASE_URL,
  defaultBpVariant: 'payStripeTest',
  language: 'de',
  languageArea: {
    firestoreId: 'de',
    tag: 'de_DE',
    countryCode: 'DE',
  },
  firebaseConfig: {
    apiKey: configuration.FIREBASE_API_KEY,
    authDomain: configuration.FIREBASE_AUTH_DOMAIN,
    databaseURL: configuration.FIREBASE_DATABASE_URL,
    projectId: configuration.FIREBASE_PROJECT_ID,
    storageBucket: configuration.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: configuration.FIREBASE_MESSAGING_SENDER_ID,
    appId: configuration.FIREBASE_APP_ID,
  },
  adyen: {
    clientKey: 'test_3PFIUQ5CDBGCZIJ2XNQ6UPX44YGSUYRO',
    embed: {
      css: {
        url: 'https://checkoutshopper-test.cdn.adyen.com/checkoutshopper/sdk/6.9.0/adyen.css',
        integrity:
          'sha384-Qy8fmdXhmf9H2Pgbmr7b0UkpeSvi7n3RFhpoZXYQPGpKIn9SH+0fT4905fsSA8Am',
        crossOrigin: 'anonymous',
      },
    },
  },
  gtmContainerId: 'GTM-PPLZJ6L',
};

export const stagingConfig: EnvConfig[] = [
  {
    ...stagingConfigBase,
    host: 'simpleclub-home.webflow.io',
  },
  {
    ...stagingConfigBase,
    host: 'simplec2.webflow.io',
  },
  {
    ...stagingConfigBase,
    // webflow project created by "flowninja"
    host: 'simple-club-dev.webflow.io',
  },
];
